import { render, staticRenderFns } from "./PlayerMessages.vue?vue&type=template&id=3eb003ec&"
import script from "./PlayerMessages.vue?vue&type=script&lang=js&"
export * from "./PlayerMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports